import { Component, computed, input } from '@angular/core';
import { FormsModule } from '@angular/forms';

/**
 * Native port of the AngularJS `ftNumberField` field-editor directive: one
 * `.modal-panel.modal-panel-input` per field with a native `<input type="number">`
 * two-way-bound to `datasource[field.name]`, plus the hidden duplicate `pattern` input.
 * Single-datasource only. Constraints (required/min/max/pattern) derive from `fieldsOptions`.
 */
@Component({
    selector: 'ft-number-field-ng',
    imports: [FormsModule],
    templateUrl: './ft-number-field.component.html'
})
export class FtNumberFieldComponent {
    /** The object whose numeric fields the inputs edit (e.g. `model.integration`). */
    readonly datasource = input<any>();
    /** A field name, or `{name,label}`, or a list of either — normalised below. */
    readonly fields = input<any>();
    /** The v1 `attrs`-derived constraints, passed raw (e.g. `{ min: 1, max: 255, required: true }`). */
    readonly fieldsOptions = input<any>();

    protected readonly normalizedFields = computed<Array<{ name: string; label: string | null }>>(() => {
        // v1 `adjustFields`: coerce string entries to {name,label:null}.
        const fields = this.fields();
        const raw = Array.isArray(fields) ? fields : fields == null ? [] : [fields];
        return raw.map((f: any) => (typeof f === 'string' ? { name: f, label: null } : f));
    });

    // v1 read attrs.required / attrs.min / attrs.max / attrs.pattern; the native modal passes the
    // raw fieldsOptions object, so derive from its keys (same defaults — min/max '' when absent).
    // v1 link-fn scope defaults (numberField.js): min/max default to '' (renders an empty attr).
    protected readonly required = computed<boolean>(() => {
        const o = this.fieldsOptions() || {};
        return (o['required'] != null && o['required'] !== false && o['required'] !== 'false') || false;
    });
    protected readonly min = computed<any>(() => {
        const o = this.fieldsOptions() || {};
        return o['min'] != null ? o['min'] : '';
    });
    protected readonly max = computed<any>(() => {
        const o = this.fieldsOptions() || {};
        return o['max'] != null ? o['max'] : '';
    });
    protected readonly pattern = computed<string>(() => (this.fieldsOptions() || {})['pattern'] || '');
}
